import React from "react";
import { Select, MenuItem } from "@material-ui/core";
import { Link } from "react-router-dom";
import { IMAGE_SETS_MENU } from "./constant";
import { useStyles } from "src/styles/ImageSetsStyles";

type ImageSetsProps = {
    imageSetsName: string,
    setImageSetsName: (imageSetsName: string) => void
}

/**
 * This component is for the "imageSet" menu, provide a dynamic list of sub-menu: "Sample Item Images" and "Canonical Images"
 */
const ImageSets: React.FunctionComponent<ImageSetsProps> = (props: ImageSetsProps) =>  {
    const styles = useStyles();

    const handleTextChange = (event: React.ChangeEvent<any>) => {
        props.setImageSetsName(event.target.value);
    }

    const listOfMenu = IMAGE_SETS_MENU.map((menuItem) => (
        <MenuItem 
            key={menuItem.title}
            value={menuItem.title}
            disabled={menuItem.disabled}>
            <Link to={menuItem.path} className={`text-white ${styles.link}`}>
                {menuItem.title}
            </Link>
        </MenuItem>
    ));
    
    return (
        <Select
            className={styles.root}
            disableUnderline
            displayEmpty
            value={props.imageSetsName}
            onChange={handleTextChange}>
            {listOfMenu}
        </Select>   
    );
}

export default ImageSets;
